"use client";

import Image from "next/image";
import Link from "next/link";

/**
 * Lobby CTA under the homepage hero — visible for guests and logged-in users.
 */
export default function GuestLobbyBanner() {
  return (
    <Link
      href="https://cdk.goatspins.com:3072/lobby/?SkinId=1"
      className="ContBannerLobby"
    >
      <Image
        src="/new-site/banner-lobby.png"
        alt="Enter the Goat Spins Lobby"
        width={1080}
        height={321}
        className="ImgBannerLobby"
      />
    </Link>
  );
}
